import { z } from "zod";
export const createTenantGroupSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
});
export const updateTenantGroupSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).nullable().optional(),
});
export const addGroupMembersSchema = z.object({
    tenantUserIds: z.array(z.string().uuid()).min(1),
});
//# sourceMappingURL=tenant-group.js.map